import {
  CheckOutlined,
  DeleteOutlined,
  EditOutlined,
  FieldTimeOutlined,
  PlusOutlined,
  SettingOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined
} from '@ant-design/icons'
import {
  Button,
  Form,
  Input,
  Select,
  Space,
  Tooltip,
  Checkbox,
  Modal,
  Divider,
  Pagination
} from 'antd'
import get from 'lodash.get'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import {
  getLabelByValue,
  hasPermission,
  removeNullUndefined,
  removeVietnameseTones
} from '../../config-func'
import { ACTION_MODE, PAGE_SIZE_OPTIONS } from '../../configData'
import {
  dataAdd,
  dataDelete,
  dataUpdate,
  getDetailData,
  getListData,
  listNote,
  noteAdd,
  noteUpdate
} from '../../services/data-customer-service'
import {
  createSelection,
  deleteSelection,
  getAllSelections,
  updateSelection
} from '../../services/selection-list-service'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import PhoneVisibilityCell from '../common/PhoneVisibilityCell'
import ExportButton from '../common/ExportButton'
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormAddExcel from './FormAddExcel'
import FormPost from './FormPost'
import {
  addressSearch,
  addressSearchAll,
  projectSearch
} from '../../services/postservice'
import Note from './Note'
import {
  getSubProductType,
  getSubProductTypeFilter,
  ProductType
} from '../PostManagement/configs'
import { current_status } from './configs'
import dayjs from 'dayjs'
import Loading from '../Loading'
const DataCustomerManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [formCategory] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [detail, setDetail] = useState()
  const [listCategory, setListCategory] = useState([])
  const [isModalImportOpen, setIsModalImportOpen] = useState(false)
  const [isModalNote, setIsModalNote] = useState(false)
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])
  const [districtsAll, setDistrictsAll] = useState([])
  const [townsAll, setTownsAll] = useState([])
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [listProject, setListProject] = useState([])
  const [typeRealEstate, setTypeRealEstate] = useState([])
  const [visibleColumns, setVisibleColumns] = useState({})
  const [isColumnSettingsOpen, setIsColumnSettingsOpen] = useState(false)
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [comments, setComments] = useState([])

  const [listSelection, setListSelection] = useState([])
  const getListSelection = async () => {
    try {
      const res = await getAllSelections()
      if (res?.data) {
        // const filteredData = res?.data?.list?.filter(item => item.category === "USER_SUPPORT");
        const filteredData = res?.data?.list
          ?.filter((item) => item.category === 'USER_SUPPORT')
          ?.sort((a, b) => a.order - b.order)
        setListSelection(filteredData)
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
    }
  }
  useEffect(() => {
    getListSelection()
  }, [])

  // Khởi tạo visibleColumns từ localStorage
  useEffect(() => {
    const savedColumns = localStorage.getItem('dataCustomerVisibleColumns')
    if (savedColumns) {
      setVisibleColumns(JSON.parse(savedColumns))
    } else {
      // Mặc định tất cả cột đều hiển thị
      const defaultColumns = {}
      initialColumns.forEach((col) => {
        defaultColumns[col.key] = true
      })
      setVisibleColumns(defaultColumns)
    }
  }, [])

  // Lưu visibleColumns vào localStorage khi thay đổi
  useEffect(() => {
    if (Object.keys(visibleColumns).length > 0) {
      localStorage.setItem(
        'dataCustomerVisibleColumns',
        JSON.stringify(visibleColumns)
      )
    }
  }, [visibleColumns])

  // Hàm toggle hiển thị cột
  const toggleColumnVisibility = (columnKey) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [columnKey]: !prev[columnKey]
    }))
  }

  // Hàm reset về mặc định
  const resetColumnVisibility = () => {
    const defaultColumns = {}
    initialColumns.forEach((col) => {
      defaultColumns[col.key] = true
    })
    setVisibleColumns(defaultColumns)
  }

  // Hàm toggle fullscreen
  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen)
    // Test toast khi toggle fullscreen
    // if (!isFullscreen) {
    //   openNotification('success', 'Đã bật chế độ toàn màn hình')
    // } else {
    //   openNotification('info', 'Đã tắt chế độ toàn màn hình')
    // }
  }

  // Xử lý phím ESC để thoát fullscreen
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isFullscreen) {
        setIsFullscreen(false)
      }
    }

    if (isFullscreen) {
      document.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isFullscreen])

  // Danh sách dự án
  const getProjectAll = async (values) => {
    let { page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { page, pageSize }
      const res = await projectSearch(body)
      const result = res?.data?.list?.map((item) => ({
        ...item,
        value: item.id,
        label: item.project_name
      }))

      setListProject(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    getProjectAll()
  }, [])

  const handleSearch = (values = {}) => {
    if (filters.currentPage === 1) {
      fetchData(values)
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }
  const handleSearchFormPost = (values = {}) => {
    fetchData({
      ...values,
      page: filters.currentPage,
      pageSize: filters.pageSize
    })
  }

  async function fetchData(values = {}) {
    setLoading(true)
    let _dataSource = []
    let _total = 0
    const value = removeNullUndefined(values)
    const { currentPage, pageSize, ...rest } = filters
    console.log('filters: ', filters)
    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      ...rest,
      ...value
    }

    // const cleanedData = Object.fromEntries(
    //   Object.entries(params).filter(
    //     ([_, value]) => value !== '' && value !== null && value !== undefined
    //   )
    // )

    try {
      const response = await getListData(params)
      _total = response?.data?.total
      _dataSource = response?.data?.list

      // }
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    if (filters.currentPage && filters.pageSize) {
      const value = formSearch.getFieldsValue()
      fetchData({
        ...value,
        page: filters.currentPage,
        pageSize: filters.pageSize
      })
    }
  }, [filters.currentPage, filters.pageSize, filters.reset])

  const lastestNoteRef = useRef(null)

  // Danh sách note
  const getListNote = async (postId) => {
    const params = {
      target_id: postId,
      target_type: 'CUSTOMERDATA'
    }

    try {
      const res = await listNote(params)
      if (res?.data) {
        lastestNoteRef.current = res?.data?.list?.[0]?.id
        setComments(res?.data?.list || [])
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
    }
  }

  const EditableContext = React.createContext(null)
  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm()
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    )
  }
  const getDetailDataCustomer = async (id) => {
    setLoading(true)
    try {
      const res = await getDetailData(id) // Assuming roleSearch is an API function
      if (res && res.data) {
        // setIsModalOpen(true)
        const values = res.data
        setDetail(values)
        getListDistricts(values.area)
        getListTowns(values.district)
        const type = getSubProductTypeFilter(values.realstate)
        setLoading(false)
        setTypeRealEstate(type)
        // form.setFieldsValue({ ...values })
      } else {
        openNotification('error', 'Không tìm thấy dữ liệu')
      }
    } catch (err) {
      setLoading(false)
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }
  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false)
    const inputRef = useRef(null)
    const form = useContext(EditableContext)
    useEffect(() => {
      if (editing) {
        inputRef.current?.focus()
      }
    }, [editing])
    const toggleEdit = () => {
      setEditing(!editing)
      form.setFieldsValue({ [dataIndex]: record[dataIndex] })
    }

    const fetchNoteUpdate = async (record) => {
      try {
        const values = await form.validateFields()
        const body = {
          note: values.lastest_note,
          target_type: 'CUSTOMERDATA',
          target_id: record.id
        }
        const res = lastestNoteRef.current
          ? await noteUpdate(body, lastestNoteRef.current)
          : await noteAdd(body)
        if (
          res?.message == 'Cập nhật thành công !' ||
          res?.message == 'Tạo thành công !'
        ) {
          openNotification('success', 'Cập nhật thành công')
          fetchData()
        }
      } catch (err) {
        const errors = get(err, 'response.data.message', [])
        // Xử lý lỗi nếu là mảng
        const errorMessages = Array.isArray(errors)
          ? errors.map((error) => error.message).join('\n')
          : errors // Nếu không phải mảng, lấy trực tiếp

        openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
      } finally {
      }
    }
    const save = async (record) => {
      try {
        const values = await form.validateFields()

        const user_support =
          values.user_support && values.user_support.join(',')

        // Cập nhật dữ liệu - values sẽ ghi đè lên record nếu có trường trùng
        await dataUpdate(
          {
            ...record, // Dữ liệu cũ từ record
            ...values, // Dữ liệu mới từ form (sẽ ghi đè nếu trùng tên trường)
            user_support: user_support
          },
          record.id
        )

        // Thông báo thành công
        openNotification('success', 'Cập nhật dữ liệu thành công!')

        // Tắt chế độ chỉnh sửa
        toggleEdit()

        // Làm mới dữ liệu bảng
        const searchValues = formSearch.getFieldsValue()
        const currentFilters = filtersRef.current
        fetchData({
          ...searchValues,
          page: currentFilters.currentPage,
          pageSize: currentFilters.pageSize
        })
      } catch (errInfo) {
        // Hiển thị thông báo lỗi chi tiết
        const errorMessage =
          errInfo?.response?.data?.message ||
          errInfo?.message ||
          'Có lỗi xảy ra khi cập nhật dữ liệu'

        openNotification('error', errorMessage)
      }
    }
    let childNode = children
    if (editable) {
      if (editing) {
        if (dataIndex === 'lastest_note') {
          childNode = (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Form.Item
                style={{ margin: 0, flex: 1 }}
                name={'lastest_note'}
                rules={[
                  { required: true, message: `${title} không được để trống.` }
                ]}
              >
                <Input
                  ref={inputRef}
                  style={{ width: '100%', minWidth: '50px' }}
                />
              </Form.Item>
              <div style={{ display: 'flex', gap: 10, marginLeft: 10 }}>
                <span
                  style={{ color: 'red', cursor: 'pointer' }}
                  onClick={() => setEditing(false)}
                >
                  Hủy
                </span>{' '}
                <span
                  onClick={() => fetchNoteUpdate(record)}
                  style={{ color: 'green', cursor: 'pointer' }}
                >
                  Lưu
                </span>
              </div>
            </div>
          )
        } else {
          // Các cột khác -> Input + nút check
          childNode = (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Form.Item
                style={{ margin: 0, flex: 1 }}
                name={dataIndex}
                rules={[
                  { required: true, message: `${title} không được để trống.` }
                ]}
              >
                <Input
                  ref={inputRef}
                  style={{ width: '100%', minWidth: '50px' }}
                />
              </Form.Item>
              {/* <CheckOutlined
              onClick={save}
              style={{ cursor: "pointer", marginLeft: 10, color: "green" }}
            /> */}
              <div style={{ display: 'flex', gap: 10, marginLeft: 10 }}>
                <span
                  style={{ color: 'red', cursor: 'pointer' }}
                  onClick={() => setEditing(false)}
                >
                  Hủy
                </span>{' '}
                <span
                  onClick={() => save(record)}
                  style={{ color: 'green', cursor: 'pointer' }}
                >
                  Lưu
                </span>
              </div>
            </div>
          )
        }
      } else {
        if (dataIndex === 'lastest_note') {
          childNode = (
            <div
              className="editable-cell-value-wrap"
              style={{
                paddingInlineEnd: 24,
                width: '250px',
                position: 'relative'
              }}
            >
              <div
                style={{
                  paddingRight: 24, // chừa chỗ cho icon
                  wordWrap: 'break-word', // xuống dòng khi dài
                  whiteSpace: 'normal' // cho phép xuống dòng
                }}
              >
                {children}
              </div>

              {hasPermission('P81.2', permissions) && (
                <EditOutlined
                  onClick={() => {
                    toggleEdit()
                    getListNote(record.id)
                  }}
                  style={{
                    cursor: 'pointer',
                    color: 'blue',
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#fff'
                  }}
                />
              )}
            </div>
          )
        } else if (dataIndex === 'status') {
          // Trường hợp nhu cầu -> Select
          childNode = (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                zIndex: 999
              }}
            >
              <Form.Item style={{ margin: 0 }} name={dataIndex}>
                <Select
                  style={{ width: '200px' }}
                  onChange={() => save(record)}
                  defaultValue={record[dataIndex]}
                  getPopupContainer={() =>
                    isFullscreen ? document.body : undefined
                  }
                  dropdownStyle={{
                    zIndex: isFullscreen ? 10001 : undefined,
                    position: isFullscreen ? 'fixed' : undefined
                  }}
                  placeholder={`Chọn nhu cầu`}
                  dropdownClassName={
                    isFullscreen ? 'fullscreen-select-dropdown' : undefined
                  }
                  dropdownMatchSelectWidth={false}
                >
                  <Select.Option value="Có">Có</Select.Option>
                  <Select.Option value="Đang">Đang</Select.Option>
                  <Select.Option value="Chưa">Chưa</Select.Option>
                  <Select.Option value="Triển khai">Triển khai</Select.Option>
                </Select>
              </Form.Item>
            </div>
          )
        } else if (dataIndex === 'funiture') {
          // Trường hợp nhu cầu -> Select
          childNode = (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Form.Item style={{ margin: 0 }} name={dataIndex}>
                <Select
                  style={{ width: '200px' }}
                  onChange={() => save(record)}
                  placeholder={`Chọn nội thất`}
                  defaultValue={record[dataIndex]}
                  getPopupContainer={() =>
                    isFullscreen ? document.body : undefined
                  }
                  dropdownStyle={{
                    zIndex: isFullscreen ? 10001 : undefined,
                    position: isFullscreen ? 'fixed' : undefined
                  }}
                  dropdownClassName={
                    isFullscreen ? 'fullscreen-select-dropdown' : undefined
                  }
                  dropdownMatchSelectWidth={false}
                >
                  <Select.Option value="Full">Full</Select.Option>
                  <Select.Option value="Cơ bản">Cơ bản</Select.Option>
                  <Select.Option value="Nguyên bản">Nguyên bản</Select.Option>
                  <Select.Option value="Thô">Thô</Select.Option>
                </Select>
              </Form.Item>
            </div>
          )
        } else if (dataIndex === 'current_status') {
          childNode = (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Form.Item style={{ margin: 0 }} name={dataIndex}>
                <Select
                  style={{ width: '250px' }}
                  defaultValue={record[dataIndex]}
                  placeholder={`Chọn trình trạng`}
                  showSearch={true}
                  filterOption={(input, option) => {
                    const inputValue =
                      removeVietnameseTones(input).toLowerCase()
                    const optionValue = removeVietnameseTones(
                      option?.children || ''
                    ).toLowerCase()
                    return optionValue.includes(inputValue)
                  }}
                  onChange={() => save(record)}
                  getPopupContainer={() =>
                    isFullscreen ? document.body : undefined
                  }
                  dropdownStyle={{
                    zIndex: isFullscreen ? 10001 : undefined,
                    position: isFullscreen ? 'fixed' : undefined
                  }}
                  dropdownClassName={
                    isFullscreen ? 'fullscreen-select-dropdown' : undefined
                  }
                  dropdownMatchSelectWidth={false}
                >
                  {current_status?.map((item) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )
        } else if (dataIndex === 'user_support') {
          childNode = (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Form.Item style={{ margin: 0 }} name={dataIndex}>
                <Select
                  mode="multiple"
                  style={{ width: '250px' }}
                  defaultValue={
                    record[dataIndex] && record[dataIndex].trim() !== ''
                      ? record[dataIndex].split(',').filter(Boolean)
                      : []
                  }
                  // defaultValue={record[dataIndex] && record[dataIndex].split(',').filter(Boolean)}
                  placeholder={`Chọn CSKH (Tên)`}
                  showSearch={true}
                  filterOption={(input, option) => {
                    const inputValue =
                      removeVietnameseTones(input).toLowerCase()
                    const optionValue = removeVietnameseTones(
                      option?.children || ''
                    ).toLowerCase()
                    return optionValue.includes(inputValue)
                  }}
                  onChange={() => save(record)}
                  getPopupContainer={() =>
                    isFullscreen ? document.body : undefined
                  }
                  dropdownStyle={{
                    zIndex: isFullscreen ? 10001 : undefined,
                    position: isFullscreen ? 'fixed' : undefined
                  }}
                  dropdownClassName={
                    isFullscreen ? 'fullscreen-select-dropdown' : undefined
                  }
                  dropdownMatchSelectWidth={false}
                >
                  {listSelection?.map((item) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )
        } else {
          childNode = (
            <div
              className="editable-cell-value-wrap"
              style={{
                paddingInlineEnd: 24,
                // width: '250px',
                position: 'relative'
              }}
            >
              <div
                style={{
                  paddingRight: 24, // chừa chỗ cho icon
                  wordWrap: 'break-word', // xuống dòng khi dài
                  whiteSpace: 'normal' // cho phép xuống dòng
                }}
              >
                {children}
              </div>

              {hasPermission('P81.2', permissions) && (
                <EditOutlined
                  onClick={() => {
                    toggleEdit()
                  }}
                  style={{
                    cursor: 'pointer',
                    color: 'blue',
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: '#fff'
                  }}
                />
              )}
            </div>
          )
        }
      }
    }

    return <td {...restProps}>{childNode}</td>
  }

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell
    }
  }

  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 120,
      align: 'center',
      render: (_, __, index) => {
        return (filters.currentPage - 1) * filters.pageSize + index + 1
      }
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 120,
      render: (_, record) => <span>{record.id}</span>
    },
    {
      title: 'Dự án',
      dataIndex: 'project',
      key: 'project',
      width: 250,
      render: (_, record) => (
        <span>
          {listProject.find((n) => n.value == record.project)?.label ||
            record.project}
        </span>
      )
    },
    {
      title: 'Loại BDS',
      dataIndex: 'realstate',
      key: 'realstate',
      width: 100,
      render: (_, record) => (
        <span>
          {ProductType.find((n) => n.value == record.realstate)?.label ||
            record.realstate}
        </span>
      )
    },
    {
      title: 'Loại hình BDS',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate',
      width: 150,
      render: (_, record) => (
        <span>
          {getLabelByValue(record.type_real_estate) || record.type_real_estate}
        </span>
      )
    },
    {
      title: 'Quan hệ',
      dataIndex: 'relationship',
      key: 'relationship',
      width: 150
    },
    {
      title: 'Thành viên Căn Hộ',
      dataIndex: 'member',
      key: 'member',
      width: 170
    },
    {
      title: 'Điện thoại',
      dataIndex: 'phone',
      key: 'phone',
      width: 170,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={record?.phone}
          customerDataId={record?.id}
          type="customerData"
        />
      )
    },
    {
      title: 'Mã căn hộ',
      dataIndex: 'apartment_code',
      key: 'apartment_code',
      width: 150
    },
    {
      title: 'Tòa',
      dataIndex: 'building',
      key: 'building',
      width: 80
    },
    {
      title: 'Tầng',
      dataIndex: 'floor',
      key: 'floor',
      width: 80
    },
    {
      title: 'Căn',
      dataIndex: 'room',
      key: 'room',
      width: 80
    },
    {
      title: 'Thông tin',
      dataIndex: 'info',
      key: 'info',
      width: 250
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      editable: true
    },
    {
      title: 'Tình trạng',
      dataIndex: 'current_status',
      key: 'current_status',
      width: 250,
      editable: true
    },
    {
      title: 'Nội thất',
      dataIndex: 'funiture',
      key: 'funiture',
      width: 150,
      editable: true
    },

    {
      title: 'Note',
      dataIndex: 'lastest_note',
      key: 'lastest_note',
      width: 300,
      editable: true
    },
    {
      title: 'Mã tin',
      dataIndex: 'post_id',
      key: 'post_id',
      width: 170,
      editable: true
    },
    {
      title: 'CSKH (Tên)',
      dataIndex: 'user_support',
      key: 'user_support',
      width: 300,
      editable: true
    },
    {
      title: 'Số lần gọi',
      dataIndex: 'number_call',
      key: 'number_call',
      width: 100
      // editable: true
    },
    {
      title: 'Times Update',
      dataIndex: 'time_note',
      key: 'time_note',
      width: 150,
      render: (_, record) => {
        return (
          <span>
            {record.time_note
              ? dayjs(record.time_note.replace('Z', '')).format(
                  'HH:mm DD/MM/YYYY'
                )
              : ''}
          </span>
        )
      }
    },

    {
      title: 'Khu vực',
      dataIndex: 'area',
      key: 'area',
      width: 150,
      render: (_, record) => (
        <span>
          {cities.find((n) => n.value == record.area)?.label || record.area}
        </span>
      )
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'district',
      key: 'district',
      width: 150,
      render: (_, record) => (
        <span>
          {districtsAll.find((n) => n.value == record.district)?.label ||
            record.district}
        </span>
      )
    },
    {
      title: 'Phường/Xã',
      dataIndex: 'tower',
      key: 'tower',
      width: 150,
      render: (_, record) => (
        <span>
          {townsAll.find((n) => n.value == record.tower)?.label || record.tower}
        </span>
      )
    },
    {
      title: 'Đường phố',
      dataIndex: 'street',
      key: 'street',
      width: 150
    },
    {
      title: 'Loại dữ liệu',
      dataIndex: 'type',
      key: 'type',
      width: 120
    },
    // {
    //   title: 'Trạng thái',
    //   dataIndex: 'status',
    //   key: 'status',
    //   width: 150,
    //   render: (_, record, index) => {
    //     const name = OPTIONS_STATUS_NOTIFICATION.find(
    //       (n) => n.value === record.status
    //     )?.name
    //     return <span>{name}</span>
    //   }
    // },

    {
      title: 'Ngày update',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 150,
      render: (_, record) => {
        return (
          <span>
            {record.updated_at
              ? dayjs(record.updated_at.replace('Z', '')).format(
                  'HH:mm DD/MM/YYYY'
                )
              : ''}
          </span>
        )
      }
    },
    {
      title: 'Hành động',
      key: 'action',
      fixed: 'right',
      width: 200,
      render: (_, record) => {
        return (
          <Space size="small">
            <>
              {/* {hasPermission('P81.4', permissions) && (
                <Tooltip title="Xem note">
                  <Button
                    onClick={() => {
                      setDetail(record)
                      setIsModalNote(true)
                    }}
                  >
                    <FieldTimeOutlined />
                    Note
                  </Button>
                </Tooltip>
              )} */}
              {hasPermission('P81.2', permissions) && (
                <Tooltip title="Chỉnh sửa">
                  <Button
                    style={{ width: 32 }}
                    icon={<EditOutlined />}
                    onClick={() => {
                      setMode(ACTION_MODE.UPDATE)
                      // setDetail(record)
                      setIsModalOpen(true)
                      getDetailDataCustomer(record.id)
                      getListNote(record.id)
                    }}
                  />
                </Tooltip>
              )}
              {hasPermission('P81.3', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xoá',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xoá data
                            <b> {record.title}</b> không?
                          </div>
                        ),
                        onOk: () => handleDeleteSelection([record.id])
                      })
                    }
                  />
                </Tooltip>
              )}
            </>
          </Space>
        )
      }
    }
  ]

  // Lọc columns dựa trên visibleColumns
  const filteredColumns = initialColumns.filter(
    (col) => visibleColumns[col.key] !== false
  )

  const columns = filteredColumns.map((col) => {
    if (!col.editable) {
      return col
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave
      })
    }
  })

  // Thêm sửa project
  const handleSave = async () => {
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      const res =
        mode == ACTION_MODE.ADD
          ? await dataAdd(data)
          : await dataUpdate(
              {
                ...data,
                user_support: data.user_support.join(',')
              },
              id
            )

      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo mới data khách hàng thành công !'
          : 'Cập nhật data khách hàng thành công !'
      )
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const handleDeleteSelection = async (ids) => {
    const body = {
      ids: ids
    }
    try {
      const res = await dataDelete(body)
      fetchData()
      setSelectedRowKeys([])
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  // Danh sách thành phố
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }
  // Danh sách quận huyện
  const getListDistricts = async (code) => {
    // const code = cities.filter((item) => item.id == i)?.[0].code
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list?.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách quận huyện
  const getListDistrictsAll = async () => {
    try {
      const res = await addressSearchAll('district')
      const result = res?.data?.list?.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setDistrictsAll(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách phường xã
  const getListTownsAll = async () => {
    try {
      const res = await addressSearchAll('town')
      const result = res?.data?.list?.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setTownsAll(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    getListCities()
    getListDistrictsAll()
    getListTownsAll()
  }, [])
  const filtersRef = useRef(filters)

  useEffect(() => {
    filtersRef.current = filters
  }, [filters])
  // Danh sách phường xã
  const getListTowns = async (code) => {
    // const type = 'town'
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list?.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    getListCities()
  }, [])

  // Chọn city hay district thì call api
  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      district: null,
      tower: null
    })
  }

  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code

    getListTowns(code)
    form.setFieldsValue({
      tower: null
    })
  }
  // Render loại hình BĐS theo loại BĐS
  const onChangePostType = (e) => {
    const type = getSubProductType(e)
    // const formattedArray = type?.map((item) => ({ value: item, label: item }))

    // Reset value and error for project_id
    form.setFields([
      {
        name: 'realstate',
        errors: []
      }
    ])
    form.setFieldsValue({
      type_real_estate: null
    })
    setTypeRealEstate(type)
  }

  const onChangePostTypeFilter = (e) => {
    const type = getSubProductTypeFilter(e)
    // const formattedArray = type?.map((item) => ({ value: item, label: item }))

    // Reset value and error for project_id
    form.setFields([
      {
        name: 'realstate',
        errors: []
      }
    ])
    form.setFieldsValue({
      type_real_estate: null
    })
    setTypeRealEstate(type)
  }

  const onChangeProject = async (value) => {
    const dataProject = _.find(listProject, (el) => el.project_name === value)

    await getListDistricts(dataProject?.city_code)
    await getListTowns(dataProject?.district_code)

    form.setFieldsValue({
      area: dataProject?.city_code ? dataProject.city_code : null,
      district: dataProject?.district_code ? dataProject.district_code : null,
      tower: dataProject?.town_code ? dataProject.town_code : null,
      street: dataProject?.address ? dataProject.address : null
    })
  }
  // const memoColumns = useMemo(
  //   () => columns,
  //   [visibleColumns, filters.currentPage, filters.pageSize]
  // )
  // const memoComponents = useMemo(() => components, [dataSource])
  // console.log('dataSource: ', dataSource)

  return (
    <>
      <Loading loading={loading} />
      {isFullscreen && (
        <style>
          {`
            .fullscreen-select-dropdown {
              z-index: 10001 !important;
            }
            .fullscreen-select-dropdown .ant-select-dropdown {
              z-index: 10001 !important;
              position: fixed !important;
            }
            .ant-select-dropdown.fullscreen-select-dropdown {
              z-index: 10001 !important;
              position: fixed !important;
            }
          `}
        </style>
      )}
      <style>
        {`
          /* CSS toàn cục để đảm bảo toast hiển thị trên fullscreen */
          [data-hot-toast] {
            z-index: 999999 !important;
            position: fixed !important;
          }
          body > div[data-hot-toast] {
            z-index: 999999 !important;
            position: fixed !important;
          }
          /* Đảm bảo toast hiển thị trên tất cả elements */
          div[data-hot-toast] {
            z-index: 999999 !important;
            position: fixed !important;
          }
        `}
      </style>
      <div
        style={{
          position: isFullscreen ? 'fixed' : 'relative',
          top: isFullscreen ? 0 : 'auto',
          left: isFullscreen ? 0 : 'auto',
          width: isFullscreen ? '100vw' : '100%',
          height: isFullscreen ? '100vh' : 'auto',
          // zIndex: isFullscreen ? 9999 : 'auto',
          backgroundColor: isFullscreen ? '#fff' : 'transparent',
          overflow: isFullscreen ? 'auto' : 'visible'
        }}
      >
        {isFullscreen && (
          <div
            style={{
              position: 'sticky',
              top: 0,
              zIndex: 10000,
              backgroundColor: '#fff',
              padding: '16px 24px',
              borderBottom: '1px solid #f0f0f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
          >
            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
              Quản lý dữ liệu khách hàng - Toàn màn hình
            </h2>
            <Button
              type="text"
              icon={<FullscreenExitOutlined />}
              onClick={toggleFullscreen}
              style={{ fontSize: '16px' }}
            >
              Thoát toàn màn hình
            </Button>
          </div>
        )}
        <Card className="mb-2">
          <FilterForm
            handleSearch={handleSearch}
            setFilters={setFilters}
            fetchData={fetchData}
            pagination={filters}
            form={formSearch}
            listProject={listProject}
            listCities={cities}
            listDistricts={districts}
            listTowns={towns}
            onChangeCity={onChangeCity}
            onChangeDistrict={onChangeDistrict}
            onChangePostType={onChangePostTypeFilter}
            typeRealEstate={typeRealEstate}
            ProductType={ProductType}
            isFullscreen={isFullscreen}
          />
        </Card>

        <Card>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              margin: '0px 50px 10px 0px',
              width: '100%'
            }}
          >
            {/* <h2 className="text-2xl font-semibold my-2">Quản lý dự án</h2> */}

            <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
              <ExportButton
                columns={columns}
                data={dataSource}
                fileName="Data_du_lieu_khach_hang"
                sheetName="Dữ liệu khách hàng"
                permission="P81.5"
              />
              <Tooltip title="Cài đặt cột">
                <Button
                  icon={<SettingOutlined />}
                  onClick={() => setIsColumnSettingsOpen(true)}
                >
                  Cột
                </Button>
              </Tooltip>
              <Tooltip
                title={isFullscreen ? 'Thoát toàn màn hình' : 'Toàn màn hình'}
              >
                <Button
                  icon={
                    isFullscreen ? (
                      <FullscreenExitOutlined />
                    ) : (
                      <FullscreenOutlined />
                    )
                  }
                  onClick={toggleFullscreen}
                >
                  {isFullscreen ? 'Thoát' : 'Toàn màn hình'}
                </Button>
              </Tooltip>
              {hasPermission('P81.1', permissions) && (
                <Button
                  type="primary"
                  key="primary"
                  onClick={() => {
                    setIsModalImportOpen(true)
                  }}
                >
                  <PlusOutlined /> Import Excel
                </Button>
              )}
              {hasPermission('P81.3', permissions) && (
                <Button
                  danger
                  // disabled={selectedRowKeys.length > 0 ? false : true}
                  type="primary"
                  onClick={() => {
                    if (selectedRowKeys.length == 0) {
                      openNotification('error', 'Vui lòng chọn dữ liệu')
                    } else {
                      showConfirm({
                        title: 'Xác nhận xoá',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xoá{' '}
                            <b>{selectedRowKeys?.length}</b> dữ liệu không?
                          </div>
                        ),
                        onOk: () => {
                          handleDeleteSelection(selectedRowKeys)
                        }
                      })
                    }
                  }}
                >
                  <DeleteOutlined />
                  Xoá
                </Button>
              )}
              {/* {hasPermission('P80.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                  setDetail(null)
                }}
              >
                <PlusOutlined />
                Tạo mới Selection
              </Button>
            )}
            {hasPermission('P80.4', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpenCategory(true)
                }}
              >
                <PlusOutlined />
                Tạo mới Category
              </Button>
            )} */}
            </div>
          </div>
          <TableField
            // components={memoComponents}
            rowClassName={() => 'editable-row'}
            loading={loading}
            // columns={memoColumns}
            columns={columns}
            dataSource={dataSource}
            // dataSource={dataSource.slice(0, 5)}
            // scroll={{
            //   x: dataSource?.list?.length > 0 ? 'max-content' : '100%',
            //   y: isFullscreen ? 'calc(100vh - 200px)' : 'calc(100vh - 400px)'
            // }}
            scroll={{ y: 600 }}
            className={`custom-table`}
            // locale={{
            //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
            // }}

            // columns={
            //   filters.isDefault === 'fixed'
            //     ? columns.filter(
            //         (item) => !['calculationMethod'].includes(item.dataIndex)
            //       )
            //     : columns.filter(
            //         (item) => !['isDefault'].includes(item.dataIndex)
            //       )
            // }

            // pagination={{
            //   current: filters.currentPage,
            //   pageSize: filters.pageSize,
            //   total: total,
            //   pageSizeOptions: PAGE_SIZE_OPTIONS,
            //   showSizeChanger: true,
            //   onShowSizeChange: (current, size) => {
            //     setFilters((prev) => ({
            //       ...prev,
            //       pageSize: size,
            //       currentPage: 1
            //     }))
            //   },
            //   onChange: (page) => {
            //     setFilters((prev) => ({ ...prev, currentPage: page }))
            //   },
            //   showTotal: (total, range) =>
            //     `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            //   locale: { items_per_page: 'bản ghi / trang' }
            // }}
            rowSelection={{
              selectedRowKeys: selectedRowKeys, // Mảng chứa các row được chọn
              onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys), // Xử lý khi chọn row
              type: 'checkbox', // Hoặc 'radio' nếu chỉ chọn được 1
              preserveSelectedRowKeys: true // Giữ selection khi phân trang
            }}
            pagination={false}
            rowKey="id"
            locale={{ emptyText: 'Không có dữ liệu' }}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '16px',
              padding: '16px 0'
            }}
          >
            <Pagination
              current={filters.currentPage}
              pageSize={filters.pageSize}
              total={total}
              pageSizeOptions={PAGE_SIZE_OPTIONS}
              showSizeChanger={true}
              showQuickJumper={true}
              showTotal={(total, range) =>
                `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
              }
              locale={{
                items_per_page: 'bản ghi / trang',
                jump_to: 'Đến trang',
                page: ''
              }}
              onChange={(page, pageSize) => {
                setFilters((prev) => ({
                  ...prev,
                  currentPage: page,
                  pageSize: pageSize || prev.pageSize
                }))
              }}
              // onShowSizeChange={(current, size) => {
              //
              //   setFilters((prev) => ({
              //     ...prev,
              //     pageSize: size,
              //     currentPage: 1
              //   }))
              // }}
            />
          </div>
        </Card>
        {/* Modal Thêm mới sản phẩm */}
        <ModalCustom
          title={
            mode == ACTION_MODE.UPDATE
              ? 'Chỉnh sửa data khách hàng'
              : mode == 'ADD'
              ? 'Thêm mới selection'
              : 'Xem chi tiết'
          }
          width={1200}
          visible={isModalOpen}
          centered
          onCancel={() => {
            setIsModalOpen(false)
            form.resetFields()
          }}
          onConfirm={async () => {
            try {
              await form.validateFields() // Kiểm tra validation trước khi tiếp tục
              handleSave() // Nếu hợp lệ thì tiếp tục xử lý
            } catch (error) {}
          }}
          confirmText={'Lưu'}
          cancelText="Đóng"
          footer={mode == 'VIEW' ? [''] : ''}
        >
          <FormPost
            form={form}
            data={detail}
            fetchData={handleSearchFormPost}
            formSearch={formSearch}
            mode={mode}
            listProject={listProject}
            listCities={cities}
            listDistricts={districts}
            listTowns={towns}
            onChangeCity={onChangeCity}
            onChangeDistrict={onChangeDistrict}
            ProductType={ProductType}
            onChangePostType={onChangePostTypeFilter}
            typeRealEstate={typeRealEstate}
            onChangeProject={onChangeProject}
            listSelection={listSelection}
            setLoading={setLoading}
            loading={loading}
            comments={comments}
            setComments={setComments}
          />
        </ModalCustom>

        <FormAddExcel
          isModalOpen={isModalImportOpen}
          setIsModalOpen={setIsModalImportOpen}
          fetchData={fetchData}
          listProject={listProject}
          setLoading={setLoading}
          loading={loading}
        />

        {/* <ModalCustom
          title="Danh sách quản lý note"
          visible={isModalNote}
          centered
          width={600}
          onCancel={() => {
            setIsModalNote(false)
          }}
          confirmText={'Lưu'}
          cancelText="Đóng"
          footer={''}
        >
          <Note postId={detail?.id} fetchData={fetchData} />
        </ModalCustom> */}

        {/* Modal Column Settings */}
        <Modal
          title={
            <span
              style={{ fontSize: '20px', fontWeight: '600', marginLeft: 16 }}
            >
              Cài đặt hiển thị cột
            </span>
          }
          open={isColumnSettingsOpen}
          onCancel={() => setIsColumnSettingsOpen(false)}
          footer={[
            <Button key="reset" onClick={resetColumnVisibility}>
              Đặt lại mặc định
            </Button>,
            <Button
              key="close"
              style={{ marginRight: 16, width: 100 }}
              type="primary"
              onClick={() => setIsColumnSettingsOpen(false)}
            >
              Đóng
            </Button>
          ]}
          width={500}
          centered
          getContainer={() => document.body}
          zIndex={isFullscreen ? 10001 : undefined}
          maskStyle={isFullscreen ? { zIndex: 10000 } : undefined}
        >
          <div
            style={{ maxHeight: '500px', overflowY: 'auto', padding: '16px' }}
          >
            {/* <div style={{ marginBottom: '16px' }}>
            <strong>Chọn cột hiển thị:</strong>
          </div> */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '8px'
              }}
            >
              {initialColumns.map((column) => (
                <div
                  key={column.key}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Checkbox
                    checked={visibleColumns[column.key] !== false}
                    onChange={() => toggleColumnVisibility(column.key)}
                  >
                    <span style={{ fontSize: '13px' }}>{column.title}</span>
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
        </Modal>

        <ModalConfirm />
      </div>
    </>
  )
}

export default DataCustomerManagement
